import React, { useState, useEffect } from 'react';
import Lottie from 'lottie-react';

const slides = [
  {
    title: 'BALANCE OUTSTANDING MANAGEMENT',
    description:
      "Efficiently track and manage retailer outstanding balances with real-time monitoring. Our comprehensive system provides instant visibility into payment statuses, credit limits, and transaction histories to streamline your distribution operations.",
  },
  {
    title: 'RETAILER INFORMATION SYSTEM',
    description:
      "Centralized retailer database with complete profile management including contact details, transaction history, credit terms, and performance analytics. Access all retailer information instantly for better relationship management and decision making.",
  },
  {
    title: 'AUTOMATED TRACKING & ALERTS',
    description:
      "Smart notification system for overdue payments, credit limit monitoring, and automated reminder scheduling. Stay on top of your distribution network with intelligent alerts and comprehensive reporting tools.",
  },
];


const AuthLayout = ({ title, subtitle, children, onBack }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [animationData, setAnimationData] = useState(null);

  const changeSlide = (direction) => {
    const totalSlides = slides.length;
    if (direction === 1) {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
    } else {
      setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
    }
    setIsPaused(true);
  };

  const handleSlideClick = (slideIndex) => {
    setCurrentSlide(slideIndex);
    setIsPaused(true);
  };

  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [isPaused]);

  useEffect(() => {
    if (isPaused) {
      const resumeTimer = setTimeout(() => {
        setIsPaused(false);
      }, 10000);
      return () => clearTimeout(resumeTimer);
    }
  }, [isPaused]);

  useEffect(() => {
    fetch('/Successcelebration.json')
      .then((response) => response.json())
      .then((data) => setAnimationData(data))
      .catch((error) => console.error('Error loading animation:', error));
  }, []);

  return (
    <div className="login-page-container">
      <div className="login-card">
        <div className="illustration-section">
          <div className="illustration-content">
            <div className="simple-illustration">
              <div className="main-icon">
                <i className="fas fa-coins"></i>
              </div>
              <div className="service-icons">
                <div className="service-icon">
                  <i className="fas fa-mobile-alt"></i>
                </div>
                <div className="service-icon">
                  <i className="fas fa-university"></i>
                </div>
                <div className="service-icon">
                  <i className="fas fa-money-bill-wave"></i>
                </div>
                <div className="service-icon">
                  <i className="fas fa-bolt"></i>
                </div>
              </div>
            </div>

            <div className="slides-container">
              {slides.map((slide, index) => (
                <div
                  key={slide.title}
                  className={`slide ${currentSlide === index ? 'active' : ''}`}
                >
                  <h2 className="illustration-title">{slide.title}</h2>
                  <p className="illustration-subtitle">{slide.description}</p>
                </div>
              ))}
            </div>

            <div className="slide-navigation">
              <button className="nav-btn prev-btn" onClick={() => changeSlide(-1)}>
                <i className="fas fa-chevron-left"></i>
              </button>
              <div className="pagination-dots">
                {slides.map((_, index) => (
                  <div
                    key={index}
                    className={`dot ${currentSlide === index ? 'active' : ''}`}
                    onClick={() => handleSlideClick(index)}
                  ></div>
                ))}
              </div>
              <button className="nav-btn next-btn" onClick={() => changeSlide(1)}>
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', flex: '1 1 0%' }}>
          <div
            className="auth-top-bar"
            style={{
              display: 'flex',
              justifyContent: onBack ? 'space-between' : 'center',
              alignItems: 'center',
              marginBottom: '0.5rem',
              marginLeft: onBack ? '1rem' : '0',
              marginRight: onBack ? '1rem' : '0',
              marginTop: '0.5rem'
            }}
          >
            {onBack && (
              <button
                type="button"
                onClick={onBack}
                className="auth-back-button"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  background: '#f1f5f9',
                  border: 'none',
                  color: '#0f172a',
                  fontSize: '1rem',
                  cursor: 'pointer',
                  boxShadow: '0 2px 6px rgba(15, 23, 42, 0.12)'
                }}
                aria-label="Go back"
              >
                <i className="fas fa-arrow-left"></i>
              </button>
            )}

            <div className="brand-logo" style={{ margin: 0 }}>
              <img
                src="/webdekho_logo.png"
                alt="WebDekho Logo"
                className="company-logo"
                style={{ height: '50px' }}
              />
            </div>

            {onBack && <div style={{ width: '40px' }}></div>}
          </div>

          <div className="login-form-section">
            <div className="login-form-container">
              <div className="lottie-animation-container">
                {animationData && (
                  <Lottie
                    animationData={animationData}
                    loop={true}
                    autoplay={true}
                    style={{ width: 180, height: 180 }}
                  />
                )}
              </div>

              <div className="login-form-content">
                {title && <h2 className="login-title">{title}</h2>}
                {subtitle && <p className="login-subtitle">{subtitle}</p>}
                {children}
              </div>
            </div>
          </div>

          <div className="footer-links">
            <a href="https://webdekho.in/about" target="_blank" rel="noopener noreferrer">About Us</a>
            <a href="https://webdekho.in/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            <a href="https://webdekho.in/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
            <a href="https://webdekho.in/refund-policy" target="_blank" rel="noopener noreferrer">Refund Policy</a>
            <a href="https://webdekho.in/cancellation-policy" target="_blank" rel="noopener noreferrer">Cancellation Policy</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;


